import React, { MouseEvent, useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import ImageContainer from '../../../components/ImageContainer';
import ImagePlaceholder from '../../../assets/images/image-placeholder.svg';
import { IDimensions } from '../../../components/interfaces/IImageContainer';

interface Props {
  imageUrls?: Array<string>
  alt: string
  imageSize: IDimensions
  thumbnailSize: IDimensions
}

const ImageGallery = ({
  imageUrls = [], alt, imageSize, thumbnailSize,
} : Props) => {
  const [activeImageUrl, setActiveImageUrl] = useState(imageUrls[0]);

  // On props change, reset state
  useEffect(() => {
    if (!imageUrls.includes(activeImageUrl)) {
      setActiveImageUrl(imageUrls[0]);
    }
  }, [imageUrls, activeImageUrl]);

  const hasMultipleImages = imageUrls.length > 1;

  const cloudinaryParams = ['c_pad'];

  const onSetActiveImage = (e: MouseEvent<HTMLButtonElement>) => {
    const { id: image } = e.currentTarget;

    setActiveImageUrl(image);
  };

  const thumbnails = imageUrls.map((image) => {
    const isActiveImage = image === activeImageUrl;

    const imageStyle = `article-modal-thumbnail ${isActiveImage ? '' : 'opacity-50'}`;

    return (
      <Button id={image} key={image} className="p-0" onClick={onSetActiveImage}>
        <ImageContainer
          placeholder={ImagePlaceholder}
          className={imageStyle}
          alt={alt}
          src={image}
          params={cloudinaryParams}
          size={thumbnailSize}
        />
      </Button>
    );
  });

  return (
    <>
      <ImageContainer
        placeholder={ImagePlaceholder}
        className="article-modal-image"
        alt={alt}
        src={activeImageUrl}
        params={cloudinaryParams}
        size={imageSize}
      />
      {hasMultipleImages && (
        <div className="d-flex justify-content-center my-2 gap-2">
          {thumbnails}
        </div>
      )}
    </>
  );
};

export default ImageGallery;
